import { forwardRef, type Ref, type SVGProps } from "react";
const IconReplyFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M12.865 7.462a2 2 0 1 0-2.73-2.924l-7.5 7a2 2 0 0 0 0 2.924l7.5 7a2 2 0 1 0 2.73-2.924L9.074 15H18a8 8 0 0 1 8 8v3a2 2 0 1 0 4 0v-3c0-6.627-5.373-12-12-12H9.074z" />
  </svg>
);
const ForwardRef = forwardRef(IconReplyFilledSVG);
ForwardRef.displayName = "IconReplyFilled";
export { ForwardRef as IconReplyFilled };
